import React from 'react';

import Subtitle from './Subtitle';

const FloatingDate = () => {
  return <Subtitle noMargin>24 07 2021</Subtitle>;
};

export default FloatingDate;
